import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { ClienteModoEnvioBoletoSelectComponent } from './select';
import { ClienteModoEnvioBoletoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteModoEnvioBoletoSelectComponent,
        ClienteModoEnvioBoletoPipe
    ],
    exports: [
        ClienteModoEnvioBoletoSelectComponent,
        ClienteModoEnvioBoletoPipe
    ],
    providers: [
        ClienteModoEnvioBoletoPipe
    ]
})
export class ClienteModoEnvioBoletoModule { }
